export const kycData = {
    identifier: "kyc",
    buttonlabel: "Verify",
    inputStyleType: "rounded",
    fields: [
      {
        identifier: "kyc-field",
        fields: [
          {
            identifier: "pan",
            label: "PAN Number",
            type: "text",
            max: 10,
            regex: "^([a-zA-Z]){3}([CPHFATBLJG]){1}([a-zA-Z]){1}([0-9]){4}([a-zA-Z]){1}?$",
            value: "",
            placeholder: "Enter your pan number",
          },
          {
            identifier: "dob",
            label: "Date Of Birth",
            type: "datePicker",
            max: 10,
            value: "",
            placeholder: "Enter your dob",
          },
        ],
      },
    ],
  };
